import { useEffect } from "react";
import { useCart } from "../context/CartContext";
import styles from "./PaymentSuccess.module.css";

export default function PaymentSuccess() {
  const { clearCart } = useCart();

  useEffect(() => {
    // Clear cart on successful payment
    clearCart();
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.icon}>✓</div>
        <h1 className={styles.title}>Payment Successful!</h1>
        <p className={styles.body}>
          Thank you for your order. We've received your payment and will be in touch shortly.
        </p>
        <p className={styles.contact}>
          Questions? WhatsApp us at{" "}
          <a href="https://wa.me/94765851400">+94 76 585 1400</a>
        </p>
        <button className={styles.homeBtn} onClick={() => window.location.href = "/"}>
          Back to Home
        </button>
      </div>
    </div>
  );
}